import * as yup from "yup";

export const PhoneNumberValidationSchema = yup.object({
  phone: yup.string().required(),
  countryCode: yup.string().nullable().optional(),
  otp: yup.string().nullable().optional(),
});
